<template>
	<div>
		<v-data-table
			:items="groupedTemplates"
			:loading="loading"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			item-key="deviceName"
			hide-default-header
			single-expand
			dense
			:items-per-page="-1"
			:height="pageHeight(174)">
			<template #item="{ item, index, expand, isExpanded }">
				<tr :class="[getRowsForDataTable(index), { 'expanded-row': isExpanded }]" @click="expand(!isExpanded)">
					<td class="text-left d-flex align-center">
						<v-icon small color="primary" class="mr-1">
							{{ isExpanded ? 'mdi-arrow-down-drop-circle' : 'mdi-arrow-right-drop-circle' }}
						</v-icon>
						{{ $i18n.locale === 'en' ? item.deviceName : item.deviceNameEsp }}
					</td>
				</tr>
			</template>
			<template #expanded-item="{ item }">
				<tr style="cursor: default; background-color: #fff !important">
					<td class="pa-3">
						<v-data-table
							:items="item.templates"
							:headers="deviceTemplateHeaders"
							dense
							:items-per-page="-1"
							hide-default-footer
							class="data-table-outline"
							fixed-header>
							<template #[`item.actions`]="{ item }">
								<v-icon color="primary" size="20" @click="editItem(item)">mdi-pencil</v-icon>
								<v-icon color="primary" size="20" @click="deleteItem(item)">mdi-delete</v-icon>
							</template>
							<template #[`item.shortDescription`]="{ item }">
								<v-tooltip left color="primary">
									<template v-slot:activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on" style="width: 100%">
											{{ item.manufacturerId }} -
											{{ getManufacturerDescription(item.manufacturerId)?.shortDescription }}
										</span>
									</template>
									<span>{{ getManufacturerDescription(item.manufacturerId)?.longDescription }}</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</td>
				</tr>
			</template>
		</v-data-table>
		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteConfirm();
			" />
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { getRowsForDataTable, showErrorAlert, showSuccessAlert } from '../../../utils/utilities';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	components: { DeleteDialog },
	data () {
		return {
			deviceTemplateHeaders: [
				{ text: this.$t('manufacturer-id'), value: 'shortDescription' },
				{ text: this.$t('actions'), value: 'actions', align: 'end' },
			],
			loading: false,
			showDeleteDialog: false,
			itemToDelete: null,
			deviceManufacturers: [],
		};
	},

	computed: {
		...mapGetters({
			pageHeight: 'pageHeight',
		}),
		...mapState({
			medicalDeviceTemplates: (state) => state.medicaldevice.medicalDeviceTemplates,
		}),
		groupedTemplates () {
			return this.medicalDeviceTemplates.reduce((groups, template) => {
				let group = groups.find((g) => g.deviceName === template.deviceName);
				if (!group) {
					group = { deviceName: template.deviceName, deviceNameEsp: template.deviceNameEsp, templates: [] };
					groups.push(group);
				}
				group.templates.push(template);
				return groups;
			}, []);
		},
	},

	async mounted () {
		await this.getMedicalDeviceTemplate();

		const deviceManufacturerResponse = await this.getVerifiers('MEDICAL_DEVICE_MANUFACTURER');
		this.deviceManufacturers = deviceManufacturerResponse;
	},

	methods: {
		...mapActions({
			getMedicalDeviceTemplate: 'medicaldevice/getMedicalDeviceTemplate',
			setDeviceTemplateSelected: 'medicaldevice/setDeviceTemplateSelected',
			getVerifiersForDomain: 'verifiers/getVerifiersForDomain',
		}),
		getRowsForDataTable,
		getManufacturerDescription (lowValue) {
			return this.deviceManufacturers.find((m) => m.lowValue === lowValue);
		},
		async getVerifiers (domainValue) {
			const header = { domainValue };
			return await this.getVerifiersForDomain(header);
		},
		// ✅ ADD THESE
		editItem (item) {
			this.setDeviceTemplateSelected(item);
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'device template edit',
			});

			// open edit dialog / route
		},

		deleteItem (item) {
			this.itemToDelete = item;
			this.showDeleteDialog = true;
			// open confirm dialog
		},
		async deleteConfirm () {
			await this.$store.dispatch('medicaldevice/deleteMedicalDeviceTemplate', this.itemToDelete.id).then((res) => {
				if (res.resFlag) {
					showSuccessAlert(this.$t('success-operation'));
					this.getMedicalDeviceTemplate();
					this.getHospitals();
				} else {
					showErrorAlert(this.$t('failed-operation'));
				}
				this.showDeleteDialog = false;
				this.itemToDelete = null;
			});
		},
	},
	watch: {
		'$store.state.detailsDrawer': {
			async handler (newVal) {
				if (!newVal) {
					await this.getMedicalDeviceTemplate();
				}
			},
			deep: true,
		},
		'$store.state.updateDrawer': {
			async handler (newVal) {
				if (!newVal) {
					await this.getMedicalDeviceTemplate();
				}
			},
			deep: true,
		},
	},
};
</script>

<style scoped></style>
